/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";

/** Components */
import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Table, TableHead, TableRow, TableBody, TableCell } from "@mui/material";
import FileInput from "../../commons/FileInput.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Functions */
import { convertToMoneyWordEN } from "./../../../services/libService";
import { useTranslation } from "react-i18next";
import moment from "moment";

import ReactHtmlParser from "react-html-parser";

const FormCIForShip = ({ data = "", onCheckbox, onCheckAll, onChange, isPrint }) => {
  useEffect(() => {
    console.log(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [selectedProductIndex, setSelectedProductIndex] = useState(-1);

  const renderTable = () => {
    if (data.ciproducts?.length)
      return (
        <Table aria-label="spanning table" size="small" border={1}>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Number
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                BL
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                BL Date
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Name of Vessel
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Location
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Type of Delivery
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Route
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" colSpan={2}>
                Quantity
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                UnitPrice (USD)
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Amount (USD)
              </TableCell>
              {Boolean(onCheckbox) && (
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                  Debtor days
                </TableCell>
              )}
              {Boolean(!isPrint) && (
                <>
                  <TableCell rowSpan={2} padding="checkbox" align="center" style={{ padding: 3, border: "1px solid gray", whiteSpace: "nowrap", display: onCheckbox ? "" : "none" }}>
                    <Button variant="contained" color="secondary" onClick={onCheckAll}>
                      Select all
                    </Button>
                  </TableCell>
                </>
              )}
            </TableRow>
            <TableRow>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center">
                MT
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center">
                US Barrels
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.ciproducts.map((item, index) => (
              <TableRow
                key={index}
                onClick={(e) => {
                  if (!onChange) return;
                  e.stopPropagation(true);
                  setSelectedProductIndex(index);
                }}
                style={{ cursor: onChange ? "pointer" : "" }}
              >
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {index + 1}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {item.bl}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", whiteSpace: "nowrap" }} align="center">
                  {item.bldate && moment(item.bldate).format("DD-MMM-YY")}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {item.vessel}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {item.location}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {item.de_type}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {item.saletype}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {item.mt?.toLocaleString()}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {Math.round(item.quantity)?.toLocaleString()}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {item.price ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(item.price) : "-"}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.amount)}
                </TableCell>
                {Boolean(onCheckbox) && (
                  <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                    {item.period == "loading" ? <CircularProgress size={20} /> : item.period}
                  </TableCell>
                )}
                {Boolean(!isPrint) && (
                  <>
                    <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                      <Checkbox
                        disabled={item.period == "loading"}
                        style={{ display: onCheckbox ? "" : "none" }}
                        onClick={(e) => e.stopPropagation()}
                        checked={item.isCreateBK || false}
                        onChange={(e, value) => onCheckbox(index, value)}
                      />
                      <div hidden={Boolean(onCheckbox)}>
                        <a hidden={!item.blfile} href={item.blfile} download style={{ whiteSpace: "nowrap" }}>
                          B/L file
                        </a>
                      </div>
                    </TableCell>
                  </>
                )}
              </TableRow>
            ))}
            <TableRow>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" colSpan={7}>
                Total
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {data?.ciproducts
                  .filter((i) => i.isCreateBK !== false)
                  .reduce((p, c) => p + c.mt, 0)
                  ?.toLocaleString()}
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {Math.round(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + c.quantity, 0))?.toLocaleString()}
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right"></TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2 }).format(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + c.amount, 0))}
              </TableCell>
              {Boolean(onCheckbox) && <TableCell padding="checkbox" align="center" style={{ border: "1px solid gray", fontWeight: "bold" }}></TableCell>}
              {Boolean(!isPrint) && <TableCell padding="checkbox" align="center" style={{ border: "1px solid gray", fontWeight: "bold" }}></TableCell>}
            </TableRow>
          </TableBody>
        </Table>
      );
  };
  if (data)
    return (
      <>
        {/* <div id="civiewer" style={{ margin: "20px auto", padding: "0px 30px" }}> */}
        <table width="100%" className="mt-1 pb-1" style={{ fontSize: 14 }}>
          <tbody>
            <tr>
              <td colSpan={4}>
                <div style={{ position: "relative", marginBottom: 20 }}>
                  <img alt="" src="/logoP2.png" width="75px" style={{ position: "absolute", left: 75 }} />
                  <div align="center" style={{ width: "100%", color: "#071b63", fontWeight: 700, fontSize: 22, textTransform: "uppercase" }}>
                    Commercial Invoice
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td align="right">
                <div style={{ width: 200 }} align="left">
                  No. {data.code}
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td align="right">
                <div style={{ width: 200 }} align="left">
                  Date: {data.effective_time && moment(data.effective_time).format("MMM DD, YYYY")}
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Seller:</td>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>PETROLIMEX AVIATION., JSC</td>
            </tr>
            <tr>
              <td></td>
              <td style={{ textAlign: "left" }}>Floor 6, Mipec Tower, 229 Tay Son Str. , Dong Da Dist. , Hanoi, Vietnam</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Buyer:</td>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>{data.customer?.rpl_ci ? data.customer?.fullname : data.customer?.name}</td>
            </tr>
            <tr hidden={!data.customer.address}>
              <td style={{ textAlign: "left", fontWeight: "bold" }}></td>
              <td style={{ textAlign: "left" }}>{data.customer.address}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Contract No:</td>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>{data.ciinfos?.contract_no}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left" }}>Port of Loading:</td>
              <td style={{ textAlign: "left" }}>{data.ciinfos?.port_loading}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left" }}>Port of Discharge:</td>
              <td style={{ textAlign: "left" }}>{data.ciinfos?.port_discharge}</td>
            </tr>
            <tr>
              <td colSpan={2} style={{ textAlign: "left" }}>
                {ReactHtmlParser(data.note)}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Product:</td>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Jet A-1</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Delivery term:</td>
              <td style={{ textAlign: "left" }}>{data.ciinfos?.delivery_term}</td>
            </tr>
            {/* <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Price:</td>
              <td style={{ textAlign: "left" }}>
                MOPS {moment(data.ciinfos?.price_date).format("MMM YYYY")} + Premium ({data.currency}/{data.ciinfos?.price_unit})
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}></td>
              <td style={{ textAlign: "left" }}>
                {data.ciinfos?.price_Mops} + {data.ciinfos?.price_premium} = {data.ciinfos?.price_no}
              </td>
            </tr> */}
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }}>Due Date:</td>
              <td style={{ textAlign: "left" }}>{moment(data.end_effective_time).format("MMM DD, YYYY")}</td>
            </tr>
            {/* Render Table here */}
            <tr>
              <td colSpan={2}>{renderTable()}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "left" }} colSpan={2}>
                In words: {convertToMoneyWordEN(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + c.amount, 0))}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "left" }} colSpan={2}>
                (10% VAT is included in total amount for domestic ship){" "}
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "left" }} colSpan={2}>
                <div style={{ fontWeight: "bold", textDecoration: "underline" }}>Payment intruction:</div>
                <div>Please remit the above amount upon the receipt of the scanned Invoice to:</div>
              </td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Company:
              </td>
              <td align="left">PETROLIMEX AVIATION., JSC</td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Address:
              </td>
              <td align="left">6th Floor, Mipec Tower, No. 299 Tay Son Str., Dong Da Dist., Hanoi, Vietnam</td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Remittance bank:
              </td>
              <td align="left">{data.bact?.bank_code}</td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Short name:
              </td>
              <td align="left">{data.bank?.code}</td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Address:
              </td>
              <td align="left">{data.bank?.en_address}</td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Account name:
              </td>
              <td align="left">PETROLIMEX AVIATION., JSC</td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Account number:
              </td>
              <td align="left">{data.bact?.act_number}</td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Swiftcode:
              </td>
              <td align="left">{data.bact?.swift_code}</td>
            </tr>
            {/* <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Intermediary Bank:
              </td>
              <td align="left">{data.bank?.ibank}</td>
            </tr>
            <tr>
              <td align="left" style={{ paddingLeft: 50 }}>
                Swiftcode:
              </td>
              <td align="left">{data.bank?.ibswiftcode}</td>
            </tr> */}
            <tr>
              <td style={{ textAlign: "left", fontWeight: "bold" }} colSpan={2}>
                <b>When making settlement, please quote Invoice No.</b>
              </td>
            </tr>
            <tr>
              <td></td>
              <td align="center">
                <b>PETROLIMEX AVIATION</b>
              </td>
            </tr>
          </tbody>
        </table>
        <FormUpdateCIProductDialog
          open={selectedProductIndex >= 0}
          onClose={() => setSelectedProductIndex(-1)}
          initialData={data?.ciproducts[selectedProductIndex]}
          onSave={(newValue) => onChange?.(selectedProductIndex, newValue)}
        />
        {/* </div> */}
      </>
    );
  else return "";
};
export default FormCIForShip;

const FormUpdateCIProductDialog = ({ onClose, onSave, initialData, open }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState();
  const handleChange = (e) => {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleSelectFile = (file) => {
    const fr = new FileReader();
    fr.onload = (e) => {
      setInput((prev) => ({ ...prev, blfile: e.target.result, file }));
    };
    fr.readAsDataURL(file);
  };
  const handleSave = () => {
    onSave?.(input);
    onClose?.();
  };
  useEffect(() => {
    if (!initialData) return;
    setInput(initialData);
  }, [initialData]);
  return (
    <Dialog open={Boolean(open)} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Thông tin Bill of Lading</DialogTitle>
      <DialogContent style={{ paddingTop: 20 }}>
        <TextField style={{ marginBottom: 15 }} fullWidth name="bl" label="BL" value={input?.bl || ""} onChange={handleChange} />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Ngày BL")}
          value={input?.bldate}
          onChange={(value) => setInput((prev) => ({ ...prev, bldate: value }))}
          sx={{ marginBottom: "15px", width: "100%" }}
        />
        <TextField style={{ marginBottom: 15 }} fullWidth name="vessel" label="Phương tiện" value={input?.vessel || ""} onChange={handleChange} />
        <FileInput label={t("File upload")} fullWidth accept=".pdf" value={input?.file} onChange={handleSelectFile} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <Button variant="contained" onClick={handleSave}>
          {t("Lưu")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
